import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/5_olive/5_olive"
 * Contains 1 texture(s)
 */
export class Tablet5OliveAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/5_olive/5_olive';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '5_olive.png'
    ] as const;
}
